import { useEffect } from 'react';

/**
 * Turns off the browser's pull-to-refresh while the calling component is
 * mounted. Grids and text sheets scroll their own content, and a swipe down
 * at the top kept reloading the page by accident. Pages that don't call this
 * (Home, Settings, Calendar) keep pull-to-refresh.
 */
export function useNoPullToRefresh(): void {
  useEffect(() => {
    const targets = [document.documentElement, document.body];
    const previous = targets.map((el) => el.style.overscrollBehaviorY);
    targets.forEach((el) => { el.style.overscrollBehaviorY = 'none'; });
    return () => {
      targets.forEach((el, i) => { el.style.overscrollBehaviorY = previous[i] ?? ''; });
    };
  }, []);
}
